// MET-468: customer-facing copy for the lapsed effective date banner, the
// Requested Effective Date card and its editor. Kept in one place so the
// business can change it without touching the components.
export const EFFECTIVE_DATE_COPY = {
  bannerHeadline: (newDate: string) =>
    `Your requested effective date has been updated to today, ${newDate}.`,
  bannerPastDate: (oldDate: string) =>
    `The date on your saved quote (${oldDate}) is in the past, and coverage can't start before today.`,
  bannerReview: 'Please review your quote before you buy.',
  bannerChangeDate: 'Change date',
  bannerDismissLabel: 'Dismiss',
  cardTitle: 'Requested Effective Date',
  cardEdit: 'Edit',
  cardUpdatedFrom: (oldDate: string) =>
    `Updated from ${oldDate} — that date has passed`,
  editorTitle: 'Change your requested effective date',
  editorPrompt: 'When would you like your coverage to start?',
  editorInvalidDate: (expireDate: string) =>
    `Please choose a date from today up to the day before ${expireDate}, or start a new application.`,
  editorSaveFailed: "We couldn't update your effective date. Please try again.",
  editorSave: 'Save',
  editorCancel: 'Cancel'
} as const;
